import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter, Redirect } from 'react-router-dom';


import { Progress, Image } from 'C4';
import { appContentUrl } from 'settings';

const Overlay = (props) => {
  const { id } = props;
  return (
    <div id={`overlay_${id}`} className="overlay">
      <i id={`lock_${id}`} className="fas fa-lock" />
    </div>
  );
};

class TrainingCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: '',
      loading: true,
    };
  }

  redirect(url, page, path) {
    const { redirPath, history } = this.props;
    if (page === undefined) {
      history.push(`${path !== undefined ? path : redirPath}${url}/0`);
    } else {
      history.push(`${path !== undefined ? path : redirPath}${url}/${page}`);
    }
  }

  render() {
    const {
      appId,
      chapter,
      chapterCount,
      chaptersProgress,
      history,
      index,
      locked,
      lockedSubtitle,
      // lockedSubtitleRedirect,
      redirPath,
    } = this.props;

    const { loading, redirect } = this.state;

    let buttonText;
    let redir;
    switch (chaptersProgress.percentage) {
      case 100:
        buttonText = i18n.translate('trainingScreens.restart');
        redir = () => {
          history.push(`${redirPath}${chapter.chapterID}/0`);
        };
        break;
      case undefined:
      case 0:
        buttonText = i18n.translate('trainingScreens.start');
        break;
      default:
        buttonText = i18n.translate('trainingScreens.continue');
    }

    if (redir === undefined) {
      redir = (path) => {
        this.redirect(chapter.chapterID, chaptersProgress.last_page, path);
      };
    }

    return (
      <div
        role="button"
        tabIndex={index}
        onKeyPress={() => { redir(); }}
        onClick={() => { redir(); }}
        className={`trainingCard ${loading ? 'loading' : ''} ${locked ? 'locked' : ''}`}
      >
        <div className="textContainer">
          {!loading &&
          <div>
            <h3>{chapter.chapterTitle}</h3>
            {!locked && <p><FontAwesomeIcon icon={['far', 'clock']} />{`${chapterCount} ${i18n.translate('trainingScreens.durationInMinutes')}`}</p>}
            {!locked &&
              <button onClick={(e) => { e.stopPropagation(); redir(redirPath); }}>
                {buttonText}
              </button>}
            {locked && lockedSubtitle && <p >{i18n.translate('trainingScreens.unlock', { number: index + 1 })}</p>}
          </div>}
        </div>
        <div className="imageContainer">
          <Image
            load={() => { this.setState({ loading: false }); }}
            src={`${appContentUrl}${appId}/appChapter/${chapter.chapterImage.substring(chapter.chapterImage.lastIndexOf('/'))}`}
            alt={chapter.chapterTitle}
            gradient
            staticImage
          />
          {!loading && locked && <Overlay id={index} />}
          {!loading &&
            <span className="chapterNumber">{(`0${index + 1}`).slice(-2)}</span> &&
            <span className="chapterComplete">
              {chaptersProgress.percentage === 100 && !locked && <FontAwesomeIcon icon={['far', 'check-circle']} className="chapterComplete" />}
            </span>
          }
        </div>
        {!locked && !loading && <Progress id={index} value={chaptersProgress.percentage} />}
        {!locked && redirect.length > 0 && <Redirect to={redirect} />}
      </div>
    );
  }
}

export default withRouter(TrainingCard);

TrainingCard.propTypes = {
  appId: PropTypes.number.isRequired,
  chapter: PropTypes.shape({
    chapterID: PropTypes.string,
    chapterImage: PropTypes.string,
    chapterImagePro: PropTypes.string,
    chapterItemCount: PropTypes.number,
    chapterNumber: PropTypes.string,
    chapterTitle: PropTypes.string,
  }).isRequired,
  chapterCount: PropTypes.number,
  chaptersProgress: PropTypes.shape({
    chapter: PropTypes.string,
    last_page: PropTypes.number,
    percentage: PropTypes.number,
    progress: PropTypes.number,
    total_pages: PropTypes.number,
  }),
  history: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  locked: PropTypes.bool,
  lockedSubtitle: PropTypes.string,
  // lockedSubtitleRedirect: PropTypes.string,
  redirPath: PropTypes.string,
};

TrainingCard.defaultProps = {
  chapterCount: 0,
  chaptersProgress: {},
  locked: false,
  redirPath: '/main/training/chapter/',
  lockedSubtitle: null,
  // lockedSubtitleRedirect: '',
};

Overlay.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};
